import React from 'react';
import PropTypes from 'prop-types';

export function ResponseIcon({ title }) {
  return (
    <svg
      width="150"
      viewBox="0 0 151 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      title={title}
    >
      <path
        d="M66.379 116.859s-.222-4.343-2.941-6.116c-2.478-1.621-4.73-1.384-6.351-1.113l-14.054 2.973.035-3.784s2.686-2.754.743-6.808l-18.83-.838-1.802 10.449s-7.32-.382-11.103.113c-3.784.495-8.176 2.162-10 6.757-1.824 4.594.203 9.1.203 9.1s2.318 5.719 9.324 6.216l10.227.197.17-7.619h-.027l-7.689-.305s-3.97.068-4.157-2.5c-.078-1.081.27-2.27 1.368-2.938 1.538-.946 4.324-.83 6.843-.643l21.892 1.216s5.097-.159 8.208-.978c3.21-.846 9.527-2.162 9.527-2.162l2.265 13.921h7.838l-1.69-15.138z"
        fill="#E86CDD"
      />
      <path
        d="M21.987 134.011s1.462.087 1.908.246c1.165.416 3.535 2.219 3.535 2.219s1.74-5.37-.354-7.76c-1.986-2.262-4.792-2.329-5.076-2.329l-.17 7.619.157.005zM64.15 137.265c3.243.175 7.702 0 7.702 0s1.262-.052 1.316-.811c.049-.657-.438-.897-.962-1.184-.524-.286-3.313-1.7-4.14-3.273H60.23l.241 1.484s.435 3.608 3.678 3.784z"
        fill="#2C1044"
      />
      <path
        d="M121.04 72.094s-14.054 4.392-19.73 10.54c-5.675 6.15-8.513 19.663-10.067 30.744L79.529 111.6l1.081-8.898s2.787-14.45 5.644-20.608c2.905-6.264 7.162-17.567 37.702-22.905l13.841 4.324s.651 7.614-3.897 12.568c0 0-5.182 8.065-6.082 14.235a26.288 26.288 0 00.9 11.305l6.803 14.595-10.135 5.903-5.946-10.992s-4.1-8.243-4.594-15.406c-.495-7.162 3.424-18.019 6.194-23.627z"
        fill="#A03DE9"
      />
      <path
        d="M137.798 63.514s9.322-12.77 10.743-18.244c0 0 3.152-12.386-.632-18.062-3.784-5.675-16.935-8.648-16.935-8.648l-2.343 5.135 13.221 7.454-.429 10.675s-.157 2.23-2.222 2.052c-1.673-.146-25.211-2.973-25.211-2.973s-5.313-.992-8.513 1.284c-3.2 2.275-11.395 8.446-11.395 8.446l4.527 3.918 11.014-6.486s9.797 1.824 12.746 2.049c0 0-.541 1.532-.203 2.297.338.765 2.186 1.486 2.186 1.486l-.405 5.292 13.851 4.325z"
        fill="#2C1044"
      />
      <path
        d="M135.365 43.44l.392-2.402a5.58 5.58 0 001.916-5c-.43-3.222-1.959-4.527-3.986-5.135-2.027-.609-4.865.516-5.7 2.724l-.495 1.103a3.207 3.207 0 01-.686.754 8.983 8.983 0 00-.811.664.543.543 0 00-.069.724.536.536 0 00.204.166l.54.338a21.27 21.27 0 00-.502 2.259c-.043.578-.157 1.216.751 1.549.908.332 2.054.64 2.054.64l.033.87 6.359.746z"
        fill="#E86CDD"
      />
      <path
        d="M129.935 31.435c.625.926.864 2.06.665 3.16-.349 1.813-.924 4.989-.924 4.989l8.165 2.546 1.013.27s.176-.981.249-1.703c.167-1.643 1.103-5.573-1.273-8.027-2.376-2.454-6.433-2.843-7.895-1.235z"
        fill="#A03DE9"
      />
      <path
        d="M128.172 33.194l3.835 1.108-.6-3.689s-2.386.468-3.235 2.581z"
        fill="#A03DE9"
      />
      <path
        d="M128.737 23.462s-2.56-1.646-3.1-1.932a10.53 10.53 0 00-3.514-1.403s-.795-.127-.735-.6c.059-.473.608-.438 1.022-.378 1.01.168 2.01.39 2.997.665 0 0-1.833-1.233-3.006-1.646 0 0-.718-.222-.556-.7.162-.479 1.156-.154 1.156-.154s2.433.846 3.446 1.283c0 0-2.162-1.367-3.462-2.067 0 0-.581-.314-.405-.735.176-.422 1.081-.084 1.081-.084s2.516 1.165 3.032 1.478c0 0-.329-.81-2.392-1.892 0 0-.737-.38-.513-.81.224-.43 1.138-.068 1.138-.068a19.905 19.905 0 013.835 2.381s-.295-.973-.414-1.378c0 0-.178-.62.195-.716.427-.111.708.27 1.192 1.14.484.87 1.216 2.703 1.216 2.703l-2.213 4.913zM94.454 50.954a46.395 46.395 0 00-3.854 3.427c-1.87 1.892-2.267 2.346-1.924 2.681.27.27.832-.18.832-.18l2.14-1.622s-1.723 2.005-1.983 2.432c-.26.427-.36.686-.178.9.18.214.594.024 1.462-.81a23.154 23.154 0 011.97-1.666s-1.8 2.262-2.397 2.995c0 0-.395.432-.09.722.306.289.933-.136 1.203-.452s2.163-2.265 2.163-2.265S92.392 58.954 92.3 60a.429.429 0 00.16.462c.246.192.662-.18.932-.63a23.621 23.621 0 012.365-2.848s-.64 1.227-.168 2.205c.056.11.154.194.27.233a.54.54 0 00.636-.425c.227-1.013.984-4.132 1.921-4.616"
        fill="#E86CDD"
      />
      <path
        d="M81.71 111.933s-.824 2.137-6.584 4.689c0 0-2.162.773-1.705 1.503.194.321.97.478.97.478l12.662 1.33s2.246.456 2.568-1.2c.321-1.657.91-5.463.91-5.463l-8.821-1.337zM126.68 121.441s.708 2.181-2.162 7.791c0 0-1.081 1.814-.378 2.241.408.251.997-.192.997-.192l10.727-6.992s2.033-1.062 1.238-2.548c-.795-1.487-2.735-4.817-2.735-4.817l-7.687 4.517zM27.834 120.54l-.578 3.514s-2.297 7.4 3.852 9.359c6.148 1.96 6.148-2.873 6.148-2.873l1.273-.213s.676-.089.743-.541c.068-.451-.202-.732-1.486-1.44 0 0 .248-3.379.248-3.898 0-.519-.083-1.148-.778-1.248-.694-.1-1.913-.316-1.913-.316l.145-2.917s-2.272-.978-7.689.541"
        fill="#2C1044"
      />
      <path
        d="M27.256 123.997s2.638.022 3.37.046l.068 1.168s-1.276.491-1.335 1.64c-.06 1.149.1 1.933 2.213 1.865 0 0 1.13-.151 1.351.684.222.802.372 1.622.45 2.451 0 0-3.141.733-7.08-1.081-.002.008-.405-4.03.963-6.773z"
        fill="#E8E8E3"
      />
      <path
        d="M26.292 130.778s-.76.708-.556 2.735a1.072 1.072 0 00.556.655 5.59 5.59 0 00.416 1.702c.347.741 3.725 2.114 6.741 1.473 0 0 .768-.046 1.284-1.059l.565-1.025 1.035-.224a1.27 1.27 0 00.978-1.351c-.021-1.149-.046-1.311-.432-1.622a90.325 90.325 0 01-10.587-1.284zM43.45 82.66c-2.9 3.75-5.636 7.637-6.352 8.648l-.178.27s.41-7.008-1.255-17.462c-2.883.325-8.14.911-12.61 1.395a146.491 146.491 0 011.973 16.38s-2.354 4.574-.046 9.282l18.83.838 11.756-15.592s1.979-2.835 3.83-6.216l-11.838-3.47c-1.162 1.824-2.619 3.997-4.11 5.926z"
        fill="#A03DE9"
      />
      <path
        d="M30.746 54.689c-3.297 1.116-8.294 2.808-12.07 4.081a104.952 104.952 0 014.378 16.74c4.47-.483 9.73-1.08 12.611-1.394a110.913 110.913 0 00-4.919-19.427zM60.298 56.825l-.021-.044-11.622 4.708c.165.303.297.617.47.9 3.965 6.487-1.565 14.34-1.565 14.34L59.398 80.2c1.114-2.032 2.181-4.262 2.746-6.189 1.452-4.968 1.7-8.908-1.846-17.186z"
        fill="#2C1044"
      />
      <path
        d="M24.578 40.619c-3.267 1.973-8.084 4.889-11.105 6.732A69.205 69.205 0 0118.68 58.77c3.784-1.273 8.773-2.973 12.07-4.081a103.427 103.427 0 00-6.173-14.07zM52.21 44.268a5374.426 5374.426 0 01-10 8.075c2.109 2.549 4.723 5.973 6.452 9.146l11.622-4.708a46.972 46.972 0 00-8.073-12.513z"
        fill="#E8E8E3"
      />
      <path
        d="M24.353 40.192L23.3 38.549s-.753-1.333.592-3.176c1.69-2.316 2.584-3.668 2.584-3.668s.692-.945.084-1.856c-.608-.911-2.5 0-2.5 0s-4.019 1.654-13.562 9.627c0 0-1.506 1.235-.473 2.738a48.92 48.92 0 013.446 5.137c3.027-1.843 7.838-4.76 11.11-6.732l-.23-.427zM51.175 43.176s-.919-1.081-.44-2.854a58.09 58.09 0 011.621-5.017s.681-1.621-.068-2.28c-1.048-.93-2.083-.411-3.14.783-1.057 1.195-10.776 11.495-10.776 11.495s-1.454 1.386.392 3.1c0 0 1.505 1.602 3.438 3.94 2.432-1.956 6.735-5.427 10-8.075-.622-.711-1.027-1.092-1.027-1.092z"
        fill="#A03DE9"
      />
      <path
        d="M132.909 36.427c-.703 2.64 3.197 3.438 3.918.916.646-2.26-3.294-3.26-3.918-.916z"
        fill="#2C1044"
      />
      <path
        d="M134.99 35.1l1.081-3.754a.314.314 0 01.446-.195c.316.127.211.592.211.592l-.811 3.832s-.973.287-.927-.475z"
        fill="#2C1044"
      />
      <path
        d="M126.39 38.457c-.043.129-.078.26-.105.394-.07.357-.097.598-.097.598s1.575-.209 2.059-.422c.484-.214.446-.373.451-.39.006-.016 0-.197-.292-.218-.291-.022-2.016.038-2.016.038z"
        fill="#E8E8E3"
      />
    </svg>
  );
}

ResponseIcon.defaultProps = {
  title: '',
};

ResponseIcon.propTypes = {
  title: PropTypes.string,
};
